// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles moved to global src/styles.css */

:host {
  display: block;
}

:host p {
  margin: 0;
  font-size: 18px;
  line-height: 1.18;
  font-family: var(--font-main);
}

:host a {
  text-decoration: none;
  color: inherit;
}

/* Desktop*/
:host .site-footer {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: var(--space-page-x) !important;
  background: var(--color-purple) !important;
  color: var(--color-white) !important;
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
  margin: 0 !important;
  box-sizing: border-box !important;
  overflow: visible !important;
}

:host .site-footer > p {
  order: 1 !important;
  margin: 0 !important;
  font-size: 18px;
  line-height: 1.18;
}

:host .footer-links {
  order: 2 !important;
  display: flex !important;
  align-items: center !important;
  gap: 40px !important;
  position: static !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

:host .footer-links a {
  color: var(--color-white) !important;
  font-weight: 500;
  text-decoration: underline;
}
 .numericText
  {
    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: "lnum" 1, "tnum" 1;
  }
/* Mobile only: links first, then copyright, all inside purple footer */
@media (max-width: 767px) {
  :host .site-footer {
    align-items: flex-start !important;
    justify-content: flex-start !important;
    flex-direction: column !important;
    gap: 14px !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
    z-index: 1 !important;
  }

  :host .footer-links {
    order: 1 !important;
    width: 100% !important;
    display: grid !important;
    grid-auto-flow: row !important;
    row-gap: 10px !important;
    column-gap: 0 !important;
    align-items: start !important;
    justify-items: start !important;
    flex-wrap: nowrap !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
  }

  :host .footer-links a {
    display: block !important;
    width: auto !important;
    white-space: normal !important;
    line-height: 1.2 !important;
  }

  :host .site-footer > p {
    order: 2 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/LSR/_layout/participant-footer/participant-footer.component.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,oCAAoC;EACpC,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;AAC5B;CACC;;IAEG,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF,uEAAuE;AACvE;EACE;IACE,kCAAkC;IAClC,sCAAsC;IACtC,iCAAiC;IACjC,oBAAoB;IACpB,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;IAC7B,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Styles moved to global src/styles.css */\r\n\r\n:host {\r\n  display: block;\r\n}\r\n\r\n:host p {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  line-height: 1.18;\r\n  font-family: var(--font-main);\r\n}\r\n\r\n:host a {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n/* Desktop*/\r\n:host .site-footer {\r\n  width: 100% !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: space-between !important;\r\n  padding: var(--space-page-x) !important;\r\n  background: var(--color-purple) !important;\r\n  color: var(--color-white) !important;\r\n  position: relative !important;\r\n  top: auto !important;\r\n  left: auto !important;\r\n  right: auto !important;\r\n  bottom: auto !important;\r\n  transform: none !important;\r\n  margin: 0 !important;\r\n  box-sizing: border-box !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n:host .site-footer > p {\r\n  order: 1 !important;\r\n  margin: 0 !important;\r\n  font-size: 18px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host .footer-links {\r\n  order: 2 !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  gap: 40px !important;\r\n  position: static !important;\r\n  top: auto !important;\r\n  left: auto !important;\r\n  right: auto !important;\r\n  bottom: auto !important;\r\n  transform: none !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n:host .footer-links a {\r\n  color: var(--color-white) !important;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n}\r\n .numericText\r\n  {\r\n    font-variant-numeric: lining-nums tabular-nums;\r\n    font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n  }\r\n/* Mobile only: links first, then copyright, all inside purple footer */\r\n@media (max-width: 767px) {\r\n  :host .site-footer {\r\n    align-items: flex-start !important;\r\n    justify-content: flex-start !important;\r\n    flex-direction: column !important;\r\n    gap: 14px !important;\r\n    overflow: visible !important;\r\n    height: auto !important;\r\n    max-height: none !important;\r\n    min-height: 0 !important;\r\n    z-index: 1 !important;\r\n  }\r\n\r\n  :host .footer-links {\r\n    order: 1 !important;\r\n    width: 100% !important;\r\n    display: grid !important;\r\n    grid-auto-flow: row !important;\r\n    row-gap: 10px !important;\r\n    column-gap: 0 !important;\r\n    align-items: start !important;\r\n    justify-items: start !important;\r\n    flex-wrap: nowrap !important;\r\n    overflow: visible !important;\r\n    height: auto !important;\r\n    max-height: none !important;\r\n    min-height: 0 !important;\r\n  }\r\n\r\n  :host .footer-links a {\r\n    display: block !important;\r\n    width: auto !important;\r\n    white-space: normal !important;\r\n    line-height: 1.2 !important;\r\n  }\r\n\r\n  :host .site-footer > p {\r\n    order: 2 !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
